import React from "react";
import ServiceCard from "./ServiceCard";

export default function Services() {

  const services = [
    {
      id: 1,
      title: "Web Development",
      description: "We build modern and scalable websites."
    },
    {
      id: 2,
      title: "App Development",
      description: "We create high-performance mobile apps."
    },
    {
      id: 3,
      title: "Digital Marketing",
      description: "We grow your business with smart marketing."
    },
    {
      id: 4,
      title: "Digital Marketing",
      description: "We grow your business with smart marketing."
    },
    {
      id: 5,
      title: "Digital Marketing",
      description: "We grow your business with smart marketing."
    },
    {
      id: 6,
      title: "Digital Marketing",
      description: "We grow your business with smart marketing."
    },
  ];

  return (
    <div>
      <h2>Our Services</h2>

      <div style={containerStyle}>
        {services.map((service) => (
          <ServiceCard
            key={service.id}
            title={service.title}
            description={service.description}
          />
        ))}
      </div>

    </div>
  );
}

const containerStyle = {
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap"
};